module.exports = __webpack_public_path__ + "img/sec2_25.7569aed0.png";